import { render, staticRenderFns } from "./OrigenFormulario.vue?vue&type=template&id=76368108&scoped=true&"
import script from "./OrigenFormulario.vue?vue&type=script&lang=js&"
export * from "./OrigenFormulario.vue?vue&type=script&lang=js&"
import style0 from "./OrigenFormulario.vue?vue&type=style&index=0&id=76368108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76368108",
  null
  
)

export default component.exports